import React from "react";
import IllustrationNewAiChatBot from "@/icons/illustrations/IllustrationNewAiChatbot";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import CreateChatbotButton from "./CreateChatbotButton";
import useAzureIndexes from "@/hooks/useAzureIndexes";
import useSubscriptions from "@/hooks/useSubscriptions";

export default function NewIndexLanding() {
  const { azureIndexes, loading } = useAzureIndexes();
  const { subscription } = useSubscriptions();

  return (
    <div>
      <div className="bg-white border-[1px] rounded-2xl flex flex-col items-center">
        <div className="flex flex-row p-4 mt-16">
          <IllustrationNewAiChatBot />
        </div>
        <div className="flex flex-col py-4 items-center">
          <div className="text-lg text-slate-800 font-semibold pb-2">
            New Training Index
          </div>
          <div className="flex flex-row text-slate-500 text-slate">
            Looks like you haven&apos;t set up any AI Training yet.
          </div>
          <div className="flex flex-row text-slate-500 text-slate">
            Start customizing your customer interactions with your first AI
            Training Index.
          </div>
        </div>
        <div className="mb-8">
          Trainings: {azureIndexes.length} / {subscription?.maxIndexCount}
        </div>
      </div>
    </div>
  );
}
